<template>
  <div class="youmaylike">
    <div class="comp-title ml-2">
      <div class="left">
        <h1 class="text-uppercase color-text-bold">
          <img src="../../../../static/img/comp-title.png"/>
          Có thể bạn thích
        </h1>
      </div>
      <div style="clear: both"></div>
    </div>

    <div class="col-container mr-2" id="data">
      <div class="item-yml" v-for="(item, i) in dataList">
        <a :href="settings.prefixSong + item.id + '/' + convertToAlias(item.song)">
          <img :src="item.thumbnail != '' ? item.thumbnail : settings.defaultThumbnailBigSong"/>
          <h4 class="song color-text">{{ item.song }}</h4>
          <h5 class="singer color-text">{{ item.singer }}</h5>
        </a>
      </div>
    </div>

    <button class="see-more bg-blue color-white text-uppercase" data-page="2" :data-link="dataLink"
            v-if="countClick < 1"
            data-div="#data" @click="showMore">Xem thêm</button>
  </div>
</template>

<script>
  import Pagination from '../../Pagination'
  export default {
    name: "YouMayLike",
    components: {
      "pagination": Pagination
    },
    data(){
      return{
        currentPage: 1,
        totalRecord: 1,
        totalPage: 2,
        previousName: "previousArrow",
        nextName: "nextArrow",
        dataList: [],
        dataLink: api.youMayLike,
        countClick: 0
      }
    },
    created(){
      this.getDataList();
    },
    methods: {
      showMore(){
        var div = $($(".see-more").attr('data-div')); //div to append
        var link = $(".see-more").attr('data-link'); //current URL
        var page = $(".see-more").attr('data-page'); //get the next page #

        var dataPost = {
          pageSize: 8,
          pageIndex: page,
          orderBy: this.settings.orderByYouMayLike
        };

        axios.post(link, dataPost)
          .then(response => {
            var res = response.data.result;
            var htmlmore = "";
            for(var i = 0; i < res.length; i++){
              var thumbnail = res[i].thumbnail != "" ? res[i].thumbnail : this.settings.defaultThumbnailBigSong;
              var prefixSong = this.settings.prefixSong;
              var alias = this.convertToAlias(res[i].song);
              htmlmore += "<div class=\"item-yml\">\n" +
                "        <a href=\"" + prefixSong + res[i].id + '/' + alias + "\" >" +
                "        <img src=\"" + thumbnail + "\"/>\n" +
                "        <h4 class=\"song color-text\">" + res[i].song + "</h4>\n" +
                "        <h5 class=\"singer color-text\">" + res[i].singer + "</h5>\n" +
                "        </a>" +
                "      </div>";
            }
            div.append(htmlmore);
          }).catch(error => {
          console.log(error);
        });

        $(".see-more").attr('data-page', (parseInt(page) + 1)); //update page #
        this.countClick++;
      },

      getDataList(){
        var dataPost = {
          pageSize: 8,
          pageIndex: this.currentPage,
          orderBy: 1
        };
        axios.post(api.youMayLike, dataPost)
          .then(response => {
            var res = response.data;
            this.dataList = res.result;
            this.totalRecord = res.totalRecord;
            //this.totalPage = res.totalPage;
          }).catch(error => {
          console.log(error);
        });
      },
      onPageChange(page){
        this.currentPage = page;
      }
    },
    watch: {
      "currentPage": {
        handler: 'getDataList',
        immediate: true
      }
    }
  }
</script>

<style scoped>
  .col-container{
    flex-wrap: wrap;
    display: flex;
    margin-left: 0.4rem;
  }
  .see-more{
    border: none;
    border-radius: 30px;
    padding: 0.2rem 1rem;
    top: -1.2rem !important;
    position: relative;
  }
</style>



// WEBPACK FOOTER //
// src/components/home/wap/YouMayLike.vue